import { render } from "./OurJob.vue?vue&type=template&id=d008ed18"
import script from "./OurJob.vue?vue&type=script&lang=js"
export * from "./OurJob.vue?vue&type=script&lang=js"

import "./OurJob.vue?vue&type=style&index=0&id=d008ed18&lang=css"

import exportComponent from "/home/soviko/htdocs/soviko.de/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__